import { Typography } from '@mui/material';
import packageJson from '../../../package.json';
import dayjs from 'dayjs';

export const VersionDisplay = () => {
  // @ts-ignore
  const version = __APP_VERSION__?.version || packageJson.version;
  // @ts-ignore
  const buildDate = __APP_VERSION__?.buildDate || new Date().toISOString();

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <Typography
        component="span"
        sx={{
          gap: 0.5
        }}
      >
        Version {version}
      </Typography>
      <Typography
        component="span"
        sx={{
          fontSize: '0.9em',
          opacity: 0.8
        }}
      >
        Built on {dayjs(buildDate).format('MMMM D, YYYY')} at {dayjs(buildDate).format('h:mm A')}
      </Typography>
    </Typography>
  );
}; 